import React, { useCallback, useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import MultiSelectPicker from '../ui/MultiSelectPicker'
import ProgressionService from '../../services/api/ProgressionService'
import { MAX_RESOURCE_SELECTION } from './constants'

const formatSelected = count => `Par ressource (${count}/${MAX_RESOURCE_SELECTION})`

const ResourceScopePicker = ({ collectId, selectedResourceIds, onChange }) => {
  const [resources, setResources] = useState([])

  useEffect(() => {
    let cancelled = false
    ProgressionService.fetchResourceOptions(collectId, null)
      .then(result => { if (!cancelled)
        setResources(result || []) })
      .catch(() => { if (!cancelled)
        setResources([]) })
    return () => { cancelled = true }
  }, [collectId])

  const options = useMemo(() => resources.map(resource => ({
    value: resource.id,
    label: resource.name
  })), [resources])

  const handleDeselectAll = useCallback(() => onChange([]), [onChange])

  return (
    <div className="tw:w-72">
      <MultiSelectPicker
        deselectAllLabel="Tout désélectionner"
        formatSelectedLabel={formatSelected}
        maxSelection={MAX_RESOURCE_SELECTION}
        noOptionsMessage="Aucune ressource"
        options={options}
        placeholder="Toutes les ressources"
        searchPlaceholder="Rechercher une ressource"
        selectedValues={selectedResourceIds}
        onChange={onChange}
        onDeselectAll={handleDeselectAll}
      />
    </div>
  )
}

ResourceScopePicker.propTypes = {
  collectId: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  selectedResourceIds: PropTypes.arrayOf(PropTypes.number).isRequired
}

export default ResourceScopePicker
